import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface MenuItemsServiceProps {
  disabled?: boolean;
  value: string;
  onChange?: (event: SelectChangeEvent<string>) => void;
  items: Array<ItemVM>;
}

const MenuItemsService = ({
  disabled,
  onChange,
  value,
  items,
}: MenuItemsServiceProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="service-label">Servizio</InputLabel>
      <PmiSelect
        labelId="service-label"
        id="service"
        name="service"
        value={value}
        label="Servizio"
        onChange={onChange}
        disabled={disabled}
      >
        {items.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MenuItemsService.displayName = 'Menu items Service component';

export default memo(MenuItemsService) as typeof MenuItemsService;
